import styled from 'styled-components';

export const SkeletonContainer = styled.span`
  .singleSkeleton {
    padding-bottom: 20px;
  }
`;
